var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "c-menu" },
    _vm._l(_vm.groups, function(items, group) {
      return _c(
        "div",
        { key: group, class: ["group", "-" + group] },
        [
          _vm.getTitle(group)
            ? _c("c-title", { staticClass: "title", attrs: { size: "5" } }, [
                _vm._v("\n      " + _vm._s(_vm.getTitle(group)) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "items" },
            _vm._l(items, function(item) {
              return _c("c-menu-item", {
                key: item.path,
                staticClass: "item",
                attrs: { item: item, group: group, "is-nuxt": _vm.isNuxt },
                on: {
                  click: function($event) {
                    return _vm.$emit("click-item", item)
                  }
                }
              })
            }),
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07efedc1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07efedc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CMenu.vue
// module id = ctak
// module chunks = 1624